/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2018 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

@import '@spectrum/spectrum-variables/stylus/spectrum-light.styl'

:local(.root)
  display flex
  width 100%
  height 100%

:local(.status)
  display flex
  height 32px
  padding-right 16px

  :global(.spectrum-StatusLight)::before
    margin-left 0

:local(.connecting)
  line-height 32px
  padding-right 16px

  :global(.spectrum-CircleLoader)
    margin-right 8px
    top 4px

:local(.loading)
  position absolute
  top 50%
  left 50%
  transform translate(-50%, -50%)

:local(.scrim)
  position absolute
  display flex
  width 100%
  height 100%
  background $spectrum-alias-background-color-modal-overlay

:local(.contentFull)
  :local(.content)
    left 53px

:local(.content)
  position absolute
  left 240px
  right 0
  flex-grow 5
  transition left .3s

:local(.header)
  margin-bottom 0px
  padding 0px 40px

:local(.headerRight)
  display flex
  justify-content flex-end

:local(.headerBarButtons)
  width inherit

:local(.headerDropdownButton)
  margin 0 16px

:local(.main)
  flex 1

  iframe
    width 100%
    height 100%
    border 0

:local(.mainPanel)
  height 100%
  position relative
  left 40px
  width calc(100% - 80px)
